import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=2e3b0fce&scoped=true&"
import script from "./Rules.vue?vue&type=script&lang=ts&"
export * from "./Rules.vue?vue&type=script&lang=ts&"
import style0 from "./Rules.vue?vue&type=style&index=0&id=2e3b0fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b0fce",
  null
  
)

export default component.exports